import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7965d9ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["line", { active: _ctx.node.selected }]),
    style: _normalizeStyle({ paddingLeft: _ctx.node.level * 8 + 'px' }),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.node.select(!_ctx.node.selected)))
  }, [
    _createElementVNode("span", {
      class: "arrow",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.node.setOpen(!_ctx.node.opened)))
    }, [
      _withDirectives(_createVNode(_component_sc_icon, {
        type: _ctx.node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'
      }, null, 8, ["type"]), [
        [_vShow, _ctx.node.children.length > 0]
      ])
    ]),
    _createVNode(_component_a_dropdown, { trigger: ['contextmenu'] }, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
              return (_openBlock(), _createBlock(_component_a_menu_item, {
                onClick: menu.handler,
                key: index
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(menu.title), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createVNode(_component_sc_btn, {
            text: "add",
            size: "small",
            handler: ()=> _ctx.$emit('add', _ctx.node.data),
            style: {"margin-right":"10px"}
          }, null, 8, ["handler"]), [
            [_vShow, _ctx.node.level > 1]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.node.data.title) + " " + _toDisplayString(_ctx.node.data.path), 1)
        ])
      ]),
      _: 1
    })
  ], 6))
}